import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/documents')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/documents', ...ROUTE_META['/platform/documents'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Documents', path: '/platform/documents' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/documents', ...ROUTE_META['/platform/documents'] })),
    ],
  }),
});
